import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import axios from "axios";
import { apiKey } from "../config/config";

const MultiLineChart = ({ lang }) => {
  const token = JSON.parse(sessionStorage.getItem("aman-admin") || "null")
    ?.admin
    ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token
    : null;
  const branchId = JSON.parse(
    JSON.parse(sessionStorage.getItem("aman-admin")).admin
  ).id;
  const [chartData, setChartData] = useState({
    series: [],
    options: {
      chart: {
        type: "line",
        height: 350,
        toolbar: { show: false },
      },
      stroke: {
        width: [3, 3, 3],
        curve: "smooth",
        dashArray: [0, 0, 0],
      },
      xaxis: {
        categories: [],
        labels: { style: { fontSize: "12px" } },
      },
      yaxis: {
        labels: {
          formatter: (val) => `SAR ${val.toLocaleString()}`,
        },
      },
      legend: {
        position: "top",
        horizontalAlign: "left",
        labels: { colors: "#000" },
        formatter: function (seriesName, opts) {
          const seriesIndex = opts.seriesIndex;
          const lastValue = opts.w.globals.series[seriesIndex].slice(-1)[0];
          return `${seriesName} SAR ${lastValue?.toLocaleString() || 0}`;
        },
      },
      grid: {
        borderColor: "#e0e0e0",
        strokeDashArray: 4,
      },
      markers: { size: 0 },
      tooltip: {
        y: {
          formatter: (val) => `SAR ${val.toLocaleString()}`,
        },
      },
    },
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get(`${apiKey}/get-contract-data`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            branch_id: branchId,
          },
        }); // 🔹 your API endpoint
        const result = data.result || [];

        // Month short names for display
        const monthNames = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];

        // Sort chronologically (optional but good practice)
        const sorted = result.sort(
          (a, b) =>
            new Date(`${a.year}-${a.month}-01`) -
            new Date(`${b.year}-${b.month}-01`)
        );

        const categories = sorted.map(
          (item) => `${monthNames[item.month - 1]} ${item.year}`
        );

        const totalDiff = sorted.map((item) => item.total_difference || 0);
        const completedDiff = sorted.map(
          (item) => item.completed_difference || 0
        );
        const defaultedDiff = sorted.map(
          (item) => item.defaulted_difference || 0
        );

        setChartData((prev) => ({
          ...prev,
          series: [
            { name: lang["Sales"] || "Sales", data: totalDiff, color: "green" },
            {
              name: lang["Payments"] || "Payments",
              data: completedDiff,
              color: "#0d6efd",
            },
            {
              name: lang["Defaults"] || "Defaults",
              data: defaultedDiff,
              color: "red",
            },
          ],
          options: {
            ...prev.options,
            xaxis: { ...prev.options.xaxis, categories },
          },
        }));
      } catch (err) {
        console.error("Error fetching chart data:", err);
      }
    };

    fetchData();
  }, [branchId, lang, token]);

  return (
    <div className="card shadow-sm p-4 mb-4 bg-light">
      <h5 className="fw-bold mb-3">
        {lang["Value Money Overview"] || "Value Money Overview"}
      </h5>
      <Chart
        options={chartData.options}
        series={chartData.series}
        type="line"
        height={350}
      />
    </div>
  );
};

export default MultiLineChart;
